export const BUTTON_VARIANTS = {
  CIRCLE: "circle",
  DEFAULT: "default",
  ROUNDED: "rounded"
};
